import { Component, OnInit, Inject,OnDestroy,ViewEncapsulation,ViewChild} from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import { HostListener } from "@angular/core";
import {appsettings, enumUIFeatureView, enumUIAction, enumUIView, enumFileNamelength} from '../../../../../app-settings';
import { EditFacilityForm,TechnologyForCreationResponse} from '../../../technologyoverlay';
import { TechnologyoverlayService } from '../../../technologyoverlay.service';
import { RollbarService } from '../../../../../rollbar';
import * as Rollbar from 'rollbar';
import { SessionCheck, generateAlertMessage, getFeatureNeedtoShow,AuthFailedMessage} from '../../../../../app-general';
import {Router} from '@angular/router';
import { Http } from '@angular/http';
import { ApiService } from '../../../../../api.service';
import { backupPhoto } from '../../../../../api';

const URL = appsettings.URLinfo+'uploadfacilityImage';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-edit-facility',
  templateUrl: './edit-facility.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./edit-facility.component.scss']
})
export class EditFacilityComponent implements OnInit,OnDestroy {
public facilityditForm : FormGroup;  
  facilityimgname;
  oldimagename;
  facilityname;
  watcher: Subscription;
  columns = 4;
  firstcolumns = 5;
  firstcolspan = 4;
  firstrowHeight="190px";
  minheight = "285px";
  Imgurl: string = appsettings.Facility_IMAGE_FOLDER;
  facilityid;
  FImage;
  SiteId = "1";
  bAddEdit:boolean=false;
  bDelete:boolean=false;

  error: string;
  dragAreaClass: string;
  
  private _onDestroy: Subject<void> = new Subject<void>();
  constructor(public http: Http,private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<EditFacilityComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any,private technologyoverlayService: TechnologyoverlayService,
   public dialog: MatDialog,@Inject(RollbarService) private rollbar: Rollbar,private apiService: ApiService)  
  { 
    
    this.facilityimgname = data.FacilityImg;
    this.facilityname = data.FacilityName;
    this.facilityid = data.FacilityId;
    this.FImage = data.FacilityImg
  
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (getFeatureNeedtoShow(enumUIFeatureView.Technology,enumUIAction.Device_Map_AddEditDelete) == enumUIView.Show) {
        this.bAddEdit = true;
        this.bDelete = true;
      }       
      if (change) {        
          if (change.mqAlias == 'xs') {
            this.columns = 2;  
            this.firstcolumns = 1; 
            this.firstcolspan = 1;
            this.firstrowHeight="60px";
            this.minheight = "auto";                
          } 
          else if (change.mqAlias == 'sm') {
            this.columns = 2;
            this.firstcolumns = 5;
            this.firstcolspan = 4; 
            this.firstrowHeight="90px";
            this.minheight = "auto";          
          }  
          else if (change.mqAlias == 'md') {
            this.columns = 2;  
            this.firstcolumns = 5;
            this.firstcolspan = 4; 
            this.firstrowHeight="190px";     
          }               
          else
          {
            this.columns = 3;  
            this.firstcolumns = 5;
            this.firstcolspan = 4;
            this.firstrowHeight="190px";              
          }
      }
    });
  }
  @ViewChild('imageInput') imageInput: any;
  public onChangeeditfacility(fileList: FileList) {
    this.saveFiles(fileList)
  }

  saveFiles(fileList: FileList) {
    if (fileList.length > 1) {
      generateAlertMessage(this.dialog, "Only one file at time allowed");
      this.facilityimgname = this.facilityimgname;
      this.imageInput.nativeElement.value = '';
      return;
    }
    var file = fileList[0];
    var file_size = fileList[0].size;
    var checkFilename;
    let removedSpaces_filename = file.name.split(' ').join('');
    checkFilename = this.apiService.checkfile_name(removedSpaces_filename);
    if (checkFilename == false) {
      generateAlertMessage(this.dialog, "File Name contains special characters");
      this.facilityimgname = this.facilityimgname;
      this.imageInput.nativeElement.value = '';
      return;
    }
    else if (removedSpaces_filename.length > enumFileNamelength.length) {
      generateAlertMessage(this.dialog, "File name cannot exceed 128 characters in length");
      this.facilityimgname = this.facilityimgname;
      this.imageInput.nativeElement.value = '';
      return;
    }
    let itemType = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length) || file.name;
    let fileTypesAllowed = ["bmp", "jpg", "png"];
    if (!fileTypesAllowed.includes(itemType.toLowerCase())) {
      generateAlertMessage(this.dialog, "The file format is not supported, Please upload Provider Photo as image file.");
      this.facilityimgname = this.facilityimgname;
      return;
    }
    pFileReader(fileList[0], this.dialog).then(data => {
      if (data == 1)
        this.uploadfiletoPath(data, fileList[0]);
      else
        this.facilityimgname = this.facilityimgname;

      this.imageInput.nativeElement.value = '';
    })
    let self;
    function pFileReader(file, _dialog: MatDialog) {
      var checkvalidIMG = 0;
      return new Promise((resolve, reject) => {
        let fileReader: FileReader = new FileReader();
        fileReader.onload = function (x) {
          self = fileReader.result;
          self = self.split('\n');

          if ((self[0].includes('PNG')) || (self[0].includes('XICC_PROFILE')) || (self[0].includes('II')) || (self[0].includes('JFIF')) || (self[0].includes('BM'))) {
            var kb = 1024;
            var size = +(file.size / kb).toFixed(2)
            if(size > (kb *2)) // 1024 is 1MB
            {
              checkvalidIMG = 2;
              generateAlertMessage(_dialog, "The maximum file size allowed for upload 2 MB");
              resolve(checkvalidIMG);
            }
            else {
              checkvalidIMG = 1;
              resolve(checkvalidIMG);
            }
          }
          else {
            checkvalidIMG = 2;
            generateAlertMessage(_dialog, "The Provider Photo file which you tried to upload is not valid image file");
            resolve(checkvalidIMG);
          }
        };

        fileReader.readAsText(file);
      });
    }

  }

  @HostListener("dragover", ["$event"]) onDragOver(event: any) {
    this.dragAreaClass = "droparea";
    event.preventDefault();
  }
  @HostListener("dragenter", ["$event"]) onDragEnter(event: any) {
    this.dragAreaClass = "droparea";
    event.preventDefault();
  }
  @HostListener("dragend", ["$event"]) onDragEnd(event: any) {
    this.dragAreaClass = "dragarea";
    event.preventDefault();
  }
  @HostListener("dragleave", ["$event"]) onDragLeave(event: any) {
    this.dragAreaClass = "dragarea";
    event.preventDefault();
  }
  @HostListener("drop", ["$event"]) onDrop(event: any) {
    this.dragAreaClass = "dragarea";
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer.files) {
      let files: FileList = event.dataTransfer.files;
      this.saveFiles(files);
    }
  }
  
  uploadfiletoPath(data,file)
  {
        var formData = new FormData(); 
        formData.append('file', file, file.name);    
        this.http.post(URL, formData).pipe(takeUntil(this._onDestroy)).subscribe((res) => {      
          let resSTR = JSON.stringify(res);
          let resJSON = JSON.parse(resSTR);                              
            this.facilityimgname = resJSON._body;
        });
  }

  backupPhoto(filename)
  {
    try
    {
      var fileitem : backupPhoto = {siteId:this.SiteId, authKey: localStorage.getItem("Authkey"),fileName: filename.toString(), isPath: "Facility"}
      this.apiService.backupPhoto(fileitem).pipe(takeUntil(this._onDestroy))
      .subscribe((Response: any[]) => {
        console.log(Response);
      });
    }
    catch(err) 
    {
      throw new Error('edit-facility.component.ts' + ' - backupPhoto() - ' + err.message);
    }
  }
 
  
  ngOnInit() {
    if (getFeatureNeedtoShow(enumUIFeatureView.Technology,enumUIAction.Device_Map_AddEditDelete) == enumUIView.Show) {
      this.bAddEdit = true;
      this.bDelete = true;
    }       
    this.facilityditForm = new FormGroup({      
      facilityname: new FormControl('', [Validators.required, Validators.maxLength(32), Validators.pattern(appsettings.Name_Pattern)]),
      facilityimage: new FormControl(''),          
    });
    this.dragAreaClass = "dragarea";
  }
  public onclickCancel = () => 
  {  
    this.thisDialogRef.close('Cancel');   
    if(!SessionCheck(this.router))
    {
        return;
    }           
  }
  public hasError = (controlName: string, errorName: string) =>
  {  
      this.facilityditForm.controls[controlName].hasError(errorName);       
  }

  public editfacilitydetails = (facilityFormValue) => 
  {  
    try
    {  
        if(!SessionCheck(this.router))
        {
          this.thisDialogRef.close('Cancel');
            return;
        }
        (document.activeElement as HTMLTextAreaElement).blur();     
        if (this.facilityditForm.valid) {
          let saveclick = document.getElementById('btnsavefacilityeditclick');
          saveclick.className = 'clsfacilitybutton mat-raised-button disablebtn';               
          this.updateFacilityInfo(facilityFormValue);
        }
    }
    catch(err)
    {
        throw new Error('edit-campus.component.ts' + ' - editfacilitydetails() - ' + err.message);
    }
  }
//Provider is the name of the site and contains the image of the site/facility
  private updateFacilityInfo = (facilityFormValue) => 
  {   
        try
        {                         
          let saveclick = document.getElementById('btnsavefacilityeditclick');
          saveclick.className = 'clsfacilitybutton mat-raised-button disablebtn';
          let updateFacility: EditFacilityForm = {
            siteId: this.SiteId,   
            authKey: localStorage.getItem("Authkey"),        
            facilityName: facilityFormValue.facilityname.replace(/\s+/g, ' ').trim(),           
            facilityImage: this.facilityimgname.toString(),
            facilityId: parseInt(this.facilityid)
          }             
          this.technologyoverlayService.updateFacilityInfo(updateFacility).pipe(takeUntil(this._onDestroy))
          .subscribe((apiresponse : TechnologyForCreationResponse[])=>{            
  
          if(apiresponse.toString() == "true")
          { 

            if(this.facilityimgname != this.FImage)
                this. backupPhoto(this.FImage);
            generateAlertMessage(this.dialog, 'Provider edited successfully.');            
          }    
          else if(apiresponse.toString() == "false")
          {
            generateAlertMessage(this.dialog, 'Provider edited failed.');  
            saveclick.className = 'clsfacilitybutton mat-raised-button disablebtn';    
            this.thisDialogRef.close('close');     
          }
          else if(apiresponse["condition"] == "Authfalse")
          {    
              this.thisDialogRef.close('close');              
              AuthFailedMessage(this.dialog,this.router);  
              return;       
          }
          this.thisDialogRef.close();
          });
         
        }
        catch(err)
        {
            throw new Error('facility.component.ts' + ' - updateFacilityInfo() - ' + err.message);
        }
 }
 
 ngOnDestroy() {
  this._onDestroy.next();
  this._onDestroy.complete();
}

}
